import React, { useState } from 'react';
import { db } from '../../../firebase';
import { ref, push } from 'firebase/database';
import { FiCheckCircle, FiBook, FiAward, FiClock, FiCode } from 'react-icons/fi';

const OLevel = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await push(ref(db, 'enquiries/olevel'), {
        ...form,
        course: 'O Level',
        createdAt: new Date().toISOString()
      });
      setSubmitted(true);
      setForm({ name: '', email: '', phone: '', message: '' });
      setTimeout(() => setSubmitted(false), 3000);
    } catch (err) {
      alert('Error saving data!');
    } finally {
      setIsLoading(false);
    }
  };

  const features = [
    { icon: <FiAward size={20} />, text: 'Government recognized certification' },
    { icon: <FiBook size={20} />, text: 'Covers IT fundamentals, programming, and internet' },
    { icon: <FiCheckCircle size={20} />, text: 'Eligibility: 10+2 or ITI Certificate' },
    { icon: <FiClock size={20} />, text: 'Duration: 1 year' },
    { icon: <FiCode size={20} />, text: 'Practical & project work included' }
  ];

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <div style={styles.badge}>Popular Course</div>
          <h2 style={styles.title}>O Level Course</h2>
          <p style={styles.subtitle}>Government recognized foundation course in computer applications</p>
        </div>

        <div style={styles.imageContainer}>
          <img 
            src="https://images.unsplash.com/photo-1513258496099-48168024aec0?auto=format&fit=crop&w=600&q=80" 
            alt="O Level" 
            style={styles.image} 
          />
        </div>

        <div style={styles.details}>
          <div style={styles.meta}>
            <span style={styles.metaItem}>1 Year Duration</span>
            <span style={styles.metaItem}>10+2 Eligibility</span>
          </div>

          <div style={styles.features}>
            {features.map((feature, index) => (
              <div key={index} style={styles.featureItem}>
                <span style={styles.featureIcon}>{feature.icon}</span>
                <span>{feature.text}</span>
              </div>
            ))}
          </div>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputGroup}>
            <input 
              type="text" 
              name="name" 
              placeholder="Your Name" 
              required 
              value={form.name} 
              onChange={handleChange} 
              style={styles.input} 
            />
          </div>
          
          <div style={styles.inputGroup}>
            <input 
              type="email" 
              name="email" 
              placeholder="Your Email" 
              required 
              value={form.email} 
              onChange={handleChange} 
              style={styles.input} 
            />
          </div>
          
          <div style={styles.inputGroup}>
            <input 
              type="text" 
              name="phone" 
              placeholder="Your Phone" 
              required 
              value={form.phone} 
              onChange={handleChange} 
              style={styles.input} 
            />
          </div>
          
          <div style={styles.inputGroup}>
            <textarea 
              name="message" 
              placeholder="Your Message" 
              required 
              value={form.message} 
              onChange={handleChange} 
              style={{...styles.input, ...styles.textarea}} 
            />
          </div>
          
          <button 
            type="submit" 
            style={submitted ? styles.submitButtonSuccess : styles.submitButton}
            disabled={isLoading}
          >
            {isLoading ? (
              'Processing...'
            ) : submitted ? (
              <>
                <FiCheckCircle style={{ marginRight: 8 }} />
                Submitted Successfully
              </>
            ) : (
              'Apply Now'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  },
  card: {
    background: '#fff',
    borderRadius: '16px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
    padding: '2.5rem',
    maxWidth: '480px',
    width: '100%',
    position: 'relative',
    overflow: 'hidden'
  },
  header: {
    textAlign: 'center',
    marginBottom: '1.5rem'
  },
  badge: {
    display: 'inline-block',
    backgroundColor: '#6C4DF6',
    color: 'white',
    padding: '0.3rem 0.8rem',
    borderRadius: '20px',
    fontSize: '0.8rem',
    fontWeight: '600',
    marginBottom: '1rem'
  },
  title: {
    color: '#2d3748',
    fontWeight: '700',
    marginBottom: '0.5rem',
    fontSize: '1.8rem'
  },
  subtitle: {
    color: '#4a5568',
    marginBottom: '0',
    fontSize: '1rem',
    lineHeight: '1.5'
  },
  imageContainer: {
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '1.5rem',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
  },
  image: {
    width: '100%',
    height: 'auto',
    display: 'block'
  },
  details: {
    marginBottom: '1.5rem'
  },
  meta: {
    display: 'flex',
    justifyContent: 'center',
    gap: '1rem',
    marginBottom: '1.5rem'
  },
  metaItem: {
    backgroundColor: '#edf2f7',
    padding: '0.4rem 0.8rem',
    borderRadius: '6px',
    fontSize: '0.9rem',
    fontWeight: '500',
    color: '#4a5568'
  },
  features: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.8rem'
  },
  featureItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.8rem',
    color: '#4a5568',
    fontSize: '0.95rem',
    lineHeight: '1.4'
  },
  featureIcon: {
    color: '#6C4DF6',
    marginTop: '0.1rem'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column'
  },
  input: {
    padding: '0.8rem 1rem',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
    fontSize: '0.95rem',
    transition: 'all 0.2s',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box'
  },
  textarea: {
    minHeight: '100px',
    resize: 'vertical'
  },
  submitButton: {
    padding: '0.8rem',
    borderRadius: '8px',
    background: 'linear-gradient(90deg, #6C4DF6, #8B5CF6)',
    color: '#fff',
    fontWeight: '600',
    border: 'none',
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'all 0.3s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '0.5rem',
    boxShadow: '0 4px 6px rgba(108, 77, 246, 0.2)'
  },
  submitButtonSuccess: {
    padding: '0.8rem',
    borderRadius: '8px',
    background: '#48BB78',
    color: '#fff',
    fontWeight: '600',
    border: 'none',
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'all 0.3s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '0.5rem'
  }
};

export default OLevel;